// Local translations
export const T = {
  en_GB: {
    advisorNotes: "Advisor Notes",
    readOnly: "Read-only (Flow completed)",
    saving: "Saving...",
    addNotes: "Add your notes here...",
    noNotes: "No notes",
    required: "A note is required before this flow can be submitted",
    saveFailed: "The note could not be saved. Your latest changes are not stored yet.",
  },
  nb_NO: {
    advisorNotes: "Rådgivernotater",
    readOnly: "Skrivebeskyttet (Flyt fullført)",
    saving: "Lagrer...",
    addNotes: "Legg til dine notater her...",
    noNotes: "Ingen notater",
    required: "Et notat må skrives før denne flyten kan sendes inn",
    saveFailed: "Notatet kunne ikke lagres. De siste endringene er ikke lagret ennå.",
  },
} as const;

/**
 * QL-712 — shown when the save is refused because the page's notes were switched off. A toast,
 * not an inline alert: the refetched flow definition removes this editor right after.
 */
export const NOT_ENABLED = {
  en_GB: {
    message: "Advisor notes have been switched off for this page. Your latest note was not saved.",
  },
  fr_FR: {
    message:
      "Les notes du conseiller ont été désactivées pour cette page. Votre dernière note n'a pas été enregistrée.",
  },
  es_ES: {
    message:
      "Las notas del asesor se han desactivado para esta página. Su última nota no se ha guardado.",
  },
  pt_BR: {
    message:
      "As notas do consultor foram desativadas para esta página. Sua última nota não foi salva.",
  },
  de_DE: {
    message:
      "Die Beraternotizen wurden für diese Seite deaktiviert. Ihre letzte Notiz wurde nicht gespeichert.",
  },
  it_IT: {
    message:
      "Le note del consulente sono state disattivate per questa pagina. L'ultima nota non è stata salvata.",
  },
  ar: { message: "تم إيقاف ملاحظات المستشار لهذه الصفحة. لم يتم حفظ ملاحظتك الأخيرة." },
  ja_JP: {
    message:
      "このページのアドバイザーノートは無効になりました。最新のノートは保存されませんでした。",
  },
  hi_IN: { message: "इस पृष्ठ के लिए सलाहकार नोट बंद कर दिए गए हैं। आपका नवीनतम नोट सहेजा नहीं गया।" },
  zh_CN: { message: "此页面的顾问备注已关闭。您的最新备注未保存。" },
  zh_TW: { message: "此頁面的顧問備註已關閉。您的最新備註未儲存。" },
  nl_NL: {
    message:
      "Adviseursnotities zijn uitgeschakeld voor deze pagina. Uw laatste notitie is niet opgeslagen.",
  },
  nb_NO: {
    message: "Rådgivernotater er slått av for denne siden. Det siste notatet ble ikke lagret.",
  },
  sv_SE: {
    message:
      "Rådgivaranteckningar har stängts av för den här sidan. Din senaste anteckning sparades inte.",
  },
  fi_FI: {
    message:
      "Neuvojan muistiinpanot on poistettu käytöstä tältä sivulta. Viimeisintä muistiinpanoa ei tallennettu.",
  },
  da_DK: { message: "Rådgivernoter er slået fra for denne side. Din seneste note blev ikke gemt." },
  is_IS: {
    message:
      "Ráðgjafaminnispunktar hafa verið gerðir óvirkir fyrir þessa síðu. Síðasta minnispunkti var ekki vistað.",
  },
} as const;
